var installedModules = {};
var moduleToHandlerMapping = {
	27001: {
		getter: function() { return function() { return __webpack_require__(32222); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.5.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@superbet-group/web.lib.config",
	},
	51422: {
		getter: function() { return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_vue_composition-api_vue_composition-api"), __webpack_require__.e("node_modules_superbet-group_web_lib_vue-utilities_dist_index_esm_js")]).then(function() { return function() { return __webpack_require__(24869); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.35.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@superbet-group/web.lib.vue-utilities",
	},
	10621: {
		getter: function() { return __webpack_require__.e("node_modules_vue_composition-api_dist_vue-composition-api_mjs").then(function() { return function() { return __webpack_require__(25706); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.7.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vue/composition-api",
	},
	52857: {
		getter: function() { return function() { return __webpack_require__(70538); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.5.18",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "vue",
	},
	62751: {
		getter: function() { return function() { return __webpack_require__(70538); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~2.6.14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "vue",
	},
	9710: {
		getter: function() { return function() { return __webpack_require__(32222); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.192.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@superbet-group/web.lib.config",
	},
	37075: {
		getter: function() { return __webpack_require__.e("node_modules_superbet-group_web_lib_utilities_dist_index_esm_js").then(function() { return function() { return __webpack_require__(6040); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.47.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@superbet-group/web.lib.utilities",
	},
	98167: {
		getter: function() { return function() { return __webpack_require__(30378); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.12.4",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@superbet-group/web.lib.flags",
	},
	62565: {
		getter: function() { return __webpack_require__.e("node_modules_superbet-group_web_lib_rest_dist_index_esm_js").then(function() { return function() { return __webpack_require__(234); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.3.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@superbet-group/web.lib.rest",
	},
	99967: {
		getter: function() { return __webpack_require__.e("node_modules_rxjs_dist_esm5_index_js").then(function() { return function() { return __webpack_require__(68023); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^7.5.7",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	24112: {
		getter: function() { return function() { return __webpack_require__(20629); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.6.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "vuex",
	},
	66897: {
		getter: function() { return __webpack_require__.e("node_modules_uuid_dist_esm-browser_index_js").then(function() { return function() { return __webpack_require__(97466); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^8.3.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "uuid",
	},
	25981: {
		getter: function() { return function() { return __webpack_require__(78345); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.5.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "vue-router",
	},
	79263: {
		getter: function() { return function() { return __webpack_require__(17152); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^8.26.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "vue-i18n",
	},
	86349: {
		getter: function() { return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_vue_composition-api_vue_composition-api"), __webpack_require__.e("node_modules_superbet-group_web_lib_ui-components_dist_src_index_js")]).then(function() { return function() { return __webpack_require__(85523); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.56.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@superbet-group/web.lib.ui-components",
	},
	26047: {
		getter: function() { return Promise.all([__webpack_require__.e("node_modules_superbet-group_web_lib_utilities_dist_index_esm_js"), __webpack_require__.e("node_modules_slugify_slugify_js-_a32d1")]).then(function() { return function() { return __webpack_require__(6040); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.22.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@superbet-group/web.lib.utilities",
	},
	51413: {
		getter: function() { return __webpack_require__.e("node_modules_vue_composition-api_dist_vue-composition-api_mjs").then(function() { return function() { return __webpack_require__(25706); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.4.9",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vue/composition-api",
	},
	91995: {
		getter: function() { return function() { return __webpack_require__(70538); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.6.14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "vue",
	},
	77019: {
		getter: function() { return Promise.all([__webpack_require__.e("node_modules_superbet-group_web_lib_utilities_dist_index_esm_js"), __webpack_require__.e("node_modules_slugify_slugify_js-_a32d1")]).then(function() { return function() { return __webpack_require__(6040); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.46.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@superbet-group/web.lib.utilities",
	},
	68055: {
		getter: function() { return function() { return __webpack_require__(32222); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.79.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@superbet-group/web.lib.config",
	},
	86831: {
		getter: function() { return __webpack_require__.e("node_modules_vue-virtual-scroller_dist_vue-virtual-scroller_esm_js").then(function() { return function() { return __webpack_require__(45896); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.12.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue-virtual-scroller",
	},
	66850: {
		getter: function() { return function() { return __webpack_require__(70538); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.6.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "vue",
	}
};
var initialConsumes = [27001];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"app": [
		27001
	],
	"webpack_sharing_consume_default_superbet-group_web_lib_vue-utilities_superbet-group_web_lib_v-a9dcad": [
		51422
	],
	"src_bootstrap_ts": [
		10621,
		52857,
		62751,
		9710,
		37075,
		98167,
		62565,
		99967,
		24112,
		66897,
		25981,
		79263,
		86349
	],
	"node_modules_superbet-group_web_lib_rest_dist_index_esm_js": [
		26047
	],
	"webpack_sharing_consume_default_vue_composition-api_vue_composition-api": [
		51413
	],
	"node_modules_superbet-group_web_lib_vue-utilities_dist_index_esm_js": [
		91995,
		77019,
		68055
	],
	"src_app_modules_sportOffer_sharedSubmodules_SportOfferEventGrid_vue": [
		86831
	],
	"src_app_modules_eventGrid_components_markets_superBets_OddsRangeSlider_OddsRangeSlider_vue": [
		66850
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}